import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
const STNInwardReportPrint = () => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
     const [searchParams] = useSearchParams();
  const id = searchParams.get("id"); 

  console.log("id:",id);

  // Default data structure for fallback
  const defaultReportData = {
    stnOutwardNo: "HEAD-OFFICE/2029/STNOUT/0001",
    fromBranch: "HEAD-OFFICE",
    toBranch: "HILARA",
    date: "31-Mar-2023",
    fromStore: "HEAD-OFFICE",
    toStore: "HILARA",
    outwardType: "Not Closed",
    status: "Not Closed",
    items: [
      {
        sNo: 1,
        itemCode: "380000000",
        description: "WIRES",
        partNo: "380000000",
        uom: "Length",
        qty: "1.00",
        price: "₹0.00",
        totalAmount: "₹0.00"
      },
      {
        sNo: 2,
        itemCode: "330111002",
        description: "tyre",
        partNo: "5695",
        uom: "Nos",
        qty: "1.00",
        price: "₹0.00",
        totalAmount: "₹0.00"
      }
    ],
    grandTotal: "₹0.00"
  };

  const saved = sessionStorage.getItem("printData");
const headerData = saved ? JSON.parse(saved) : {};
console.log("get data:", headerData);
  // Fetch data from API
  useEffect(() => {
    const fetchReportData = async () => {
      if (!id) {
        setReportData(defaultReportData);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await fetch(`https://nissi-india.com/api/stnInward_viewPrint/${id}`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
       
        
        // Check if API call was successful
        if (!data.success) {
          throw new Error('API returned unsuccessful response');
        }

        // Get the first item from data array to extract common fields
       
        
        // Format date function
        const formatDate = (dateString) => {
          if (!dateString) return new Date().toLocaleDateString('en-GB');
          const date = new Date(dateString);
          return date.toLocaleDateString('en-GB');
        };

        // Transform API data to match our component structure
        const transformedData = {
          stnOutward : headerData.isoutwardclosed,
          fromBranch: headerData.FromB || "N/A",
          toBranch: headerData.ToB || "N/A",
          date: formatDate(headerData.InwardDate),
          fromStore: headerData.FromS || "N/A",
          toStore: headerData.ToS || "N/A",
          outwardType: headerData.STNType || "Direct Outward",
         
          items: data.data ? data.data.map((item, index) => ({
            sNo: parseInt(item.rowno) || index + 1,
            itemCode: item.itemcode || "N/A",
            description: item.itemName || "N/A",
            partNo: item.partno || "N/A",
            uom: item.unitName || item.unitCode || "N/A",
            qty: item.Transfered ,
            price: item.Price ? `₹${parseFloat(item.Price).toFixed(2)}` : "₹0.00",
            totalAmount: item.IWPrice ? `₹${parseFloat(item.IWPrice).toFixed(2)}` : "₹0.00",
            grandTotal: item.IWPrice ? `₹${parseFloat(item.IWPrice).toFixed(2)}` : "₹0.00"
          })) : [],
   
        };

        setReportData(transformedData);
        setError(null);
      } catch (err) {
        console.error('Error fetching report data:', err);
        setError(err.message);
        setReportData(defaultReportData); // Use default data as fallback
      } finally {
        setLoading(false);
      }
    };
    fetchReportData();
  }, [id]);

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading report data...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!reportData) {
    return (
      <div className="max-w-4xl mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center text-red-600">
            <p className="text-lg font-semibold mb-2">Error Loading Report</p>
            <p>{error || "Failed to load report data"}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white font-sans text-sm">
      {/* API Error Warning (if using fallback data) */}
      {error && (
        <div className="mb-4 p-3 bg-yellow-100 border border-yellow-400 text-yellow-700 rounded no-print">
          <p className="text-sm">
            <strong>Note:</strong> Could not fetch data from API ({error}). Showing sample data.
          </p>
        </div>
      )}

      {/* Outer Border */}
      <div className="border-4 border-black p-4 print:border-black">
        
        {/* Header Section */}
        <div className="border-2 border-black mb-4 print:border-black">
          <div className="flex items-start p-4">
            {/* Logo Section */}
            <div className="w-32 h-20 border-2 border-black mr-6 flex items-center justify-center bg-white">
              <div className="text-center">
                <div className="w-12 h-8 bg-black mx-auto mb-1 flex items-center justify-center">
                  <span className="text-white text-xs font-bold">LOGO</span>
                </div>
                <div className="text-xs font-bold">NISSI INFOTECH</div>
                <div className="text-xs">PVT LTD</div>
              </div>
            </div>
            
            {/* Company Info */}
            <div className="flex-1 text-center">
              <h1 className="text-xl font-bold mb-1">Nissi Infotech</h1>
              <p className="text-sm mb-1">Nissi</p>
              <p className="text-sm font-bold mb-1">CIVIL CONSTRUCTION</p>
              <p className="text-xs">
                3/42-12, Nagappa colony, kavundampai,644003,Tamil Nadu, India,<br/>
                Phone No :9003744644 infraconsoft-implementation@nissiinfotech.in
              </p>
            </div>
          </div>
        </div>

        {/* Report Title */}
        <div className="text-center border-b-2 border-black pb-2 mb-4 print:border-black">
          <h2 className="text-lg font-bold underline">STN Inward Report</h2>
        </div>

        {/* Report Details */}
        <div className="grid grid-cols-2 gap-x-8 mb-4 text-sm">
          <div className="space-y-1">
            <div className="flex">
              <span className="font-bold w-32">STN Outward :</span>
              <span>{reportData.stnOutward}</span>
            </div>
            <div className="flex">
              <span className="font-bold w-32">Date:</span>
              <span>{reportData.date}</span>
            </div>
            <div className="flex">
              <span className="font-bold w-32">Outward Type:</span>
              <span>{reportData.outwardType}</span>
            </div>
          </div>
          
          <div className="space-y-1">
            <div className="flex">
              <span className="font-bold w-32">From Branch:</span>
              <span>{reportData.fromBranch}</span>
            </div>
            <div className="flex">
              <span className="font-bold w-32">From Store:</span>
              <span>{reportData.fromStore}</span>
            </div>
           
          </div>
        </div>

        <div className="grid grid-cols-2 gap-x-8 mb-6 text-sm">
          <div></div>
          <div className="space-y-1">
            <div className="flex">
              <span className="font-bold w-32">To Branch:</span>
              <span>{reportData.toBranch}</span>
            </div>
            <div className="flex">
              <span className="font-bold w-32">To Store:</span>
              <span>{reportData.toStore}</span>
            </div>
          </div>
        </div>

        {/* Items Table */}
        <div className="border-2 border-black mb-4 print:border-black">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-white print:bg-white">
                <th className="border border-black px-2 py-2 text-center w-12 print:border-black">S.No</th>
                <th className="border border-black px-2 py-2 text-center w-24 print:border-black">Item Code</th>
                <th className="border border-black px-2 py-2 text-center print:border-black">Description</th>
                <th className="border border-black px-2 py-2 text-center w-24 print:border-black">Part No</th>
                <th className="border border-black px-2 py-2 text-center w-16 print:border-black">UOM</th>
                <th className="border border-black px-2 py-2 text-center w-16 print:border-black">Qty</th>
                <th className="border border-black px-2 py-2 text-center w-20 print:border-black">Price</th>
                <th className="border border-black px-2 py-2 text-center w-24 print:border-black">Total Amount</th>
              </tr>
            </thead>
            <tbody>
              {reportData.items.map((item) => (
                <tr key={item.sNo}>
                  <td className="border border-black px-2 py-2 text-center print:border-black">{item.sNo}</td>
                  <td className="border border-black px-2 py-2 text-center print:border-black">{item.itemCode}</td>
                  <td className="border border-black px-2 py-2 print:border-black">{item.description}</td>
                  <td className="border border-black px-2 py-2 text-center print:border-black">{item.partNo}</td>
                  <td className="border border-black px-2 py-2 text-center print:border-black">{item.uom}</td>
                  <td className="border border-black px-2 py-2 text-center print:border-black">{item.qty}</td>
                  <td className="border border-black px-2 py-2 text-right print:border-black">{item.price}</td>
                  <td className="border border-black px-2 py-2 text-right print:border-black">{item.totalAmount}</td>
                </tr>
              ))}
              {/* Empty rows to fill space */}
              {reportData.items.length < 10 && [...Array(10 - reportData.items.length)].map((_, index) => (
                <tr key={`empty-${index}`} className="h-6">
                  <td className="border border-black px-2 py-2 print:border-black"></td>
                  <td className="border border-black px-2 py-2 print:border-black"></td>
                  <td className="border border-black px-2 py-2 print:border-black"></td>
                  <td className="border border-black px-2 py-2 print:border-black"></td>
                  <td className="border border-black px-2 py-2 print:border-black"></td>
                  <td className="border border-black px-2 py-2 print:border-black"></td>
                  <td className="border border-black px-2 py-2 print:border-black"></td>
                  <td className="border border-black px-2 py-2 print:border-black"></td>
                </tr>
              ))}
              {/* Grand Total Row */}
              <tr>
                <td className="border border-black px-2 py-2 print:border-black" colSpan="6"></td>
                <td className="border border-black px-2 py-2 text-center font-bold print:border-black">Grand Total :</td>
                <td className="border border-black px-2 py-2 text-right font-bold print:border-black">{reportData.items.grandTotal}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Signature Section */}
        <div className="border-2 border-black mb-4 print:border-black">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-white print:bg-white">
                <th className="border border-black px-4 py-3 text-center w-1/5 print:border-black">Transferer</th>
                <th className="border border-black px-4 py-3 text-center w-1/5 print:border-black">Site In-Charge</th>
                <th className="border border-black px-4 py-3 text-center w-1/5 print:border-black">Transferee</th>
                <th className="border border-black px-4 py-3 text-center w-1/5 print:border-black">Posted By</th>
                <th className="border border-black px-4 py-3 text-center w-1/5 print:border-black">Head Office</th>
              </tr>
            </thead>
            <tbody>
              <tr className="h-20">
                <td className="border border-black px-4 py-3 print:border-black"></td>
                <td className="border border-black px-4 py-3 print:border-black"></td>
                <td className="border border-black px-4 py-3 print:border-black"></td>
                <td className="border border-black px-4 py-3 print:border-black"></td>
                <td className="border border-black px-4 py-3 print:border-black"></td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="border-2 border-black print:border-black">
          <div className="p-2 text-right text-xs">
            <span className="font-bold">Page 1 of 1</span>
          </div>
          <div className="border-t-2 border-black p-2 text-xs print:border-black">
            Report generated by ERP-Software - www.infraconsoft.com owned by <span className="font-bold">www.nissiinfotech.com</span>
          </div>
        </div>

      </div>

      {/* Print Button */}
      <div className="mt-6 text-center no-print">
        <button
          onClick={() => window.print()}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors mr-4"
        >
          Print Report
        </button>
        {id && (
          <button
            onClick={() => window.location.reload()}
            className="bg-gray-600 text-white px-6 py-2 rounded hover:bg-gray-700 transition-colors"
          >
            Refresh Data
          </button>
        )}
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          .no-print {
            display: none !important;
          }
          body {
            margin: 0;
            padding: 10mm;
            background: white !important;
          }
          * {
            color: black !important;
            background: white !important;
            border-color: black !important;
          }
          .print\\:border-black {
            border-color: black !important;
          }
          .print\\:bg-white {
            background-color: white !important;
          }
        }
      `}</style>
    </div>
  );
};

// Example usage component to demonstrate how to use with an ID
export const ExampleUsage = () => {
  const [reportId, setReportId] = useState('');

  return (
    <div>
      <div className="mb-4 p-4 bg-gray-100 no-print">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Enter Report ID:
        </label>
        <input
          type="text"
          value={reportId}
          onChange={(e) => setReportId(e.target.value)}
          className="border border-gray-300 rounded px-3 py-2 w-64"
          placeholder="Enter STN Outward Report ID"
        />
      </div>
      <STNInwardReportPrint id={reportId} />
    </div>
  );
};

export default STNInwardReportPrint;